<template>
    <div class="home-page">
        <SiteNavbar :t="t"
                    :language="language"
                    @change-language="changeLanguage" />

        <main>
            <HeroSection :t="t" />

            <AboutSection :t="t"
                          :language="language" />

            <MissionSection :t="t" />

            <ServicesSection :t="t"
                             @select-service="selectService" />
            <ProjectsGallery :t="t"
                             :language="language" />
            <ProcessSection :t="t" />

            <ServiceArea :t="t" />

            <EstimateForm :t="t"
                          :language="language"
                          :selected-service="selectedService" />
        </main>

        <SiteFooter :t="t" />
    </div>
</template>

<script>
    import translations from '@/data/translations'
    import SiteNavbar from '@/components/SiteNavbar.vue'
    import HeroSection from '@/components/HeroSection.vue'
    import AboutSection from '@/components/AboutSection.vue'
    import MissionSection from '@/components/MissionSection.vue'
    import ServicesSection from '@/components/ServicesSection.vue'
    import ProjectsGallery from '@/components/ProjectsGallery.vue'
    import ProcessSection from '@/components/ProcessSection.vue'
    import ServiceArea from '@/components/ServiceArea.vue'
    import EstimateForm from '@/components/EstimateForm.vue'
    import SiteFooter from '@/components/SiteFooter.vue'

    export default {
        name: 'HomeView',

        components: {
            SiteNavbar,
            HeroSection,
            AboutSection,
            MissionSection,
            ServicesSection,
            ProjectsGallery,
            ProcessSection,
            ServiceArea,
            EstimateForm,
            SiteFooter
        },

        data() {
            return {
                language: localStorage.getItem('mmp-language') || 'en',
                selectedService: null
            }
        },

        computed: {
            t() {
                return translations[this.language]
            }
        },

        watch: {
            language: {
                immediate: true,

                handler(newLanguage) {
                    document.documentElement.lang = newLanguage
                    localStorage.setItem('mmp-language', newLanguage)
                }
            }
        },

        methods: {
            changeLanguage(newLanguage) {
                this.language = newLanguage
            },

            selectService(serviceIndex) {
                this.selectedService = serviceIndex
            }
        }
    }
</script>

<style scoped>
    .home-page {
        min-height: 100vh;
        overflow-x: hidden;
    }
</style>